import { createFeatureSelector, createSelector } from '@ngrx/store';

import { LoadablePageResource } from './page-resource';

export const STATE_PAGE_CONTENT = 'pageContent';

export interface PageContentState {
  [pageId: string]: LoadablePageResource;
}

export const PAGE_CONTENT_INITIAL_STATE: PageContentState = {};

const selectPageContentState =
  createFeatureSelector<PageContentState>(STATE_PAGE_CONTENT);

export const selectPageContentForId = (pageId: string) =>
  createSelector(selectPageContentState, state => state[pageId]);

export function getInitialPageContentState(): PageContentState {
  return PAGE_CONTENT_INITIAL_STATE;
}
